import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filter: {
    voucherTab: "Order Wise",
    selectedFilter: "All",
    keyword: "",
    orderdDaysTab: "today",
  },
  pagination: {
    page: 1,
    pages: 1,
  },
  ui: {
    isSearchBarOpen: false,
  },
};

const productionSlice = createSlice({
  name: "production",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setUi: (state, action) => {
      state.ui = { ...state.ui, ...action.payload };
    },
  },
});

export const { setFilter, setPagination, setUi } = productionSlice.actions;

export default productionSlice.reducer;
